import { useMemo } from "react";
import { useApplicationId } from "./useApplicationId";
import { useLazyGetRequirementAdditionalInputFieldForSectionABySGBPApplicationIdQuery, useLazyGetRequirementAdditionalInputFieldForSectionBBySGBPApplicationIdQuery, useLazyGetRequirementAdditionalInputFieldForSectionCBySGBPApplicationIdQuery, useLazyGetRequirementListForSectionABySGBPApplicationIdQuery, useLazyGetRequirementListForSectionBBySGBPApplicationIdQuery, useLazyGetRequirementListForSectionCBySGBPApplicationIdQuery } from "../../../../../../app/services/SelfEvaluationForm/selfEvalutionServiceApi";
import { useLazyFetch } from "./useLazyFetch";


const EMPTY = [];

const SECTION_QUERIES = {
    A: {
        useRequirements: useLazyGetRequirementListForSectionABySGBPApplicationIdQuery,
        useFields: useLazyGetRequirementAdditionalInputFieldForSectionABySGBPApplicationIdQuery,
    },
    B: {
        useRequirements: useLazyGetRequirementListForSectionBBySGBPApplicationIdQuery,
        useFields: useLazyGetRequirementAdditionalInputFieldForSectionBBySGBPApplicationIdQuery,
    },
    C: {
        useRequirements: useLazyGetRequirementListForSectionCBySGBPApplicationIdQuery,
        useFields: useLazyGetRequirementAdditionalInputFieldForSectionCBySGBPApplicationIdQuery,
    },
};

export function useSectionMaster(section) {
    const applicationId = useApplicationId();
    const { useRequirements, useFields } = SECTION_QUERIES[section];
    const enabled = applicationId > 0;

    const { data: requirements, isLoading: requirementsLoading } = useLazyFetch(
        useRequirements,
        applicationId,
        enabled
    );
    const { data: fields, isLoading: fieldsLoading } = useLazyFetch(
        useFields,
        applicationId,
        enabled
    );

    const fieldsByRequirement = useMemo(() => {
        const grouped = {};
        (fields ?? EMPTY).forEach((field) => {
            if (!grouped[field.sgbpRequirementId]) grouped[field.sgbpRequirementId] = [];
            grouped[field.sgbpRequirementId].push(field);
        });
        return grouped;
    }, [fields]);

    return {
        requirements: requirements ?? EMPTY,
        fieldsByRequirement,
        isLoading: requirementsLoading || fieldsLoading,
    };
}